import React from 'react';
import { NavLink } from 'react-router-dom';
import onClickOutside from 'react-onclickoutside';
import PropTypes from 'prop-types';

import Avatar from 'components/Avatar';
import MenuToggleMinimal from 'scenes/Header/components/MenuToggleMinimal/index.jsx';
import UpgradeRecruiterAccount from 'scenes/Dialog/components/UpgradeRecruiterAccount';

import { ROUTE } from 'constants/route';
import { UPGRADE_ACCOUNT_TYPE } from 'constants/upgrade-account-types';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';

import './styles.css';

class ProfileDropdown extends React.Component {
  clickHandler = e => {
    e.stopPropagation();
    this.props.toggleFunc('profile');
  };

  handleClickOutside = () => {
    this.props.toggleFunc('outsideProf');
  };

  render() {
    const { avatar, name, accountType } = this.props;
    const chevronUp = (
      <FontAwesomeIcon icon={faChevronUp} color="#fff" size="sm" />
    );
    const chevronDown = (
      <FontAwesomeIcon icon={faChevronDown} color="#fff" size="sm" />
    );

    const subMenuStatus = this.props.toggled ? 'flex' : 'none';
    const subMenuStyles = {
      display: subMenuStatus,
    };

    const menu = [
      {
        name: 'Account Settings',
        to: ROUTE.CANDIDATE_ACCOUNT,
      },
      {
        name: 'Upgrade Account',
        to: ROUTE.CANDIDATE_UPGRADE_PREMIUM,
        controlFunc:
          this.props.upgradeLink &&
          this.props.upgradeType === UPGRADE_ACCOUNT_TYPE.RECRUITER
            ? () => {
                this.handleClickOutside();
                UpgradeRecruiterAccount();
              }
            : null,
      },
      {
        name: 'Logout',
        href: ROUTE.LOGOUT,
      },
    ].filter(link =>
      this.props.upgradeLink
        ? true
        : link.to !== ROUTE.CANDIDATE_UPGRADE_PREMIUM
    );

    const nameTrimed = name.length > 25 ? name.split(' ')[0] : name;

    return (
      <div className="profile-dropdown">
        <div className="profile-dropdown__profile-pic">
          <Avatar size={45} name={name} image={avatar} />
        </div>
        <div className="profile-dropdown__text" onClick={this.clickHandler}>
          <p className="profile-dropdown__name">{nameTrimed}</p>
          <p className="profile-dropdown__message">{accountType}</p>
          <span className="profile-dropdown__icon">
            {!this.props.toggled ? chevronDown : chevronUp}
          </span>
        </div>
        <div className="profile-dropdown__toggle">
          <MenuToggleMinimal
            toggled={this.props.toggled}
            toggleFunc={this.clickHandler}
          />
        </div>

        <div
          className="profile-dropdown__submenu ignore-react-onclickoutside"
          style={subMenuStyles}
        >
          <div className="profile-dropdown__user">
            <div className="profile-dropdown__user-pic">
              <Avatar size={45} name={name} image={avatar} />
            </div>
            <div
              className="profile-dropdown__user-text"
              onClick={this.clickHandler}
            >
              <p className="profile-dropdown__name"> {name} </p>
              <p className="profile-dropdown__message">{accountType}</p>
              <span className="profile-dropdown__icon">
                {!this.props.toggled ? chevronDown : chevronUp}
              </span>
            </div>
          </div>
          <ul className="profile-dropdown__submenu-list">
            {menu.map((item, index) => (
              <li className="profile-dropdown__submenu-list-item" key={index}>
                {item.controlFunc ? (
                  <div
                    className="profile-dropdown__submenu-link"
                    onClick={item.controlFunc}
                  >
                    {item.name}
                  </div>
                ) : item.to ? (
                  <NavLink
                    to={item.to}
                    className="profile-dropdown__submenu-link"
                    onClick={this.handleClickOutside}
                  >
                    {item.name}
                  </NavLink>
                ) : (
                  <a
                    href={item.href}
                    className="profile-dropdown__submenu-link"
                  >
                    {item.name}
                  </a>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

ProfileDropdown.propTypes = {
  toggled: PropTypes.bool.isRequired,
  toggleFunc: PropTypes.func.isRequired,
  avatar: PropTypes.string,
  name: PropTypes.string,
  upgradeLink: PropTypes.bool,
  upgradeType: PropTypes.string,
  accountType: PropTypes.string,
};

export default onClickOutside(ProfileDropdown);
